module.exports = __webpack_public_path__ + "static/img/icon_weixin_gzh_qr.de2cf33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imgqr/icon_weixin_gzh_qr.png
// module id = Qi8m
// module chunks = 0